import { useState } from "react";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBRow,
  MDBCol,
  MDBContainer,
} from "mdb-react-ui-kit";

//formik
import { Formik, Form, FieldArray, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

//element component
import Button from "../../../components/element/button";
import apiServices from "../../../services/api.services";
import Input from "../../../components/element/input";
import Select from "../../../components/element/select";
import CheckBox from "../../../components/element/checkbox";
import DateMultiSelect from "../../../components/element/dateMultiSelect";
import DateRange from "../../../components/element/dateRange";
import { sweetAlertHelper } from "../../../helper/sweetalert.helper";
import { useEffect } from "react";
export default function EditModalForm4({
  getInfoDetail,
  selectedData,
  handleNextStep,
  marchantList,
  getListing,
  packageType,
  close,
  allData,
}) {
  const [dataAddOn, setDataAddOn] = useState({
    package_type: [
      {
        package_type_name: "",
        package_type_item: [
          {
            package_type_item_name: "",
            package_type_item_pricing: "",
            package_type_item_limit: "",
          },
        ],
        package_type_item_addon: [
          {
            add_on_name: "",
            add_on_item: [
              {
                add_on_item_name: "",
                add_on_item_pricing: "",
              },
            ],
          },
        ],
      },
    ],
  });

  const [data, setData] = useState({
    // title: "",
    // tag: [],
    package_type: [
      {
        package_type_name: "",
        package_type_item: [
          {
            package_type_item_name: "",
            package_type_item_pricing: "",
            package_type_item_limit: "",
          },
        ],
      },
    ],
  });

  useEffect(() => {
    if (selectedData.package.package_type.length > 0) {
      if (selectedData.package_pattern !== "additional service") {
        for (var key in selectedData.package.package_type) {
          delete selectedData.package.package_type[key][
            "package_type_item_addon"
          ];
        }
      }
      selectedData.package_pattern == "additional service"
        ? setDataAddOn({
            ...data,
            package_type: selectedData.package.package_type,
          })
        : setData({ ...data, package_type: selectedData.package.package_type });
    }
  }, []);

  const addonSchema = Yup.object({
    package_type: Yup.array(
      Yup.object().shape({
        package_type_name: Yup.string().required("required"),
        package_type_item: Yup.array(
          Yup.object().shape({
            package_type_item_name: Yup.string().required("required"),
            package_type_item_pricing: Yup.string().required("required"),
            package_type_item_limit: Yup.string().required("required"),
          })
        ),
        package_type_item_addon: Yup.array(
          Yup.object().shape({
            add_on_name: Yup.string().required("required"),
            add_on_item: Yup.array(
              Yup.object().shape({
                add_on_item_name: Yup.string().required("required"),
                add_on_item_pricing: Yup.string().required("required"),
              })
            ),
          })
        ),
      })
    ),
  });

  const useSchema = Yup.object({
    package_type: Yup.array(
      Yup.object().shape({
        package_type_name: Yup.string().required("required"),
        package_type_item: Yup.array(
          Yup.object().shape({
            package_type_item_name: Yup.string().required("required"),
            package_type_item_pricing: Yup.string().required("required"),
            package_type_item_limit: Yup.string().required("required"),
          })
        ),
      })
    ),
  });

  const handleSubmit = async (values, setFieldError, setSubmitting) => {
    try {
      if (selectedData.is_ticket_package_type_valid) {
        const response = await apiServices.updateTicket({
          id: selectedData.ticket_package_id,
          payload: {
            ticket_type: "ticket_package_type",
            method: "PUT",
            ticket_package_id: selectedData.ticket_package_id
              ? selectedData.ticket_package_id
              : "",
            id: selectedData.id ? selectedData.id : "",
            package_type: values.package_type,
            title: selectedData.package_name ? selectedData.package_name : "",
          },
        });
        if (response) {
          close();
          getListing();
          sweetAlertHelper({
            title: "Success",
            text: "Update Ticket Success",
            icon: "success",
          });
        }
      } else {
        const response = await apiServices.createTicketForm({
          payload: {
            ticket_type: "ticket_package_type",
            method: "POST",
            ticket_package_id: selectedData.ticket_package_id
              ? selectedData.ticket_package_id
              : "",
            id: selectedData.id ? selectedData.id : "",
            package_type: values.package_type,
            title: selectedData.package_name ? selectedData.package_name : "",
          },
        });

        if (response) {
          close();
          getListing();
          sweetAlertHelper({
            title: "Success",
            text: "Add Ticket Success",
            icon: "success",
          });
        }
      }
    } catch (ex) {
      let errorMsg = "";

      setSubmitting(false);
      if (ex && Object.keys(ex).length > 0) {
        if (ex.response.status === 422) {
          const errors = ex.response.data.errors;
          if (errors && Object.keys(errors).length > 0) {
            Object.keys(errors).map((item, i) => {
              setFieldError(item, errors[item]);
              errorMsg = errors[item];
            });
          }
        }
        sweetAlertHelper({
          title: "Error",
          text: `${errorMsg}`,
          icon: "error",
        });
      }
    }
  };

  return (
    <Formik
      enableReinitialize={true}
      validateOnChange={true}
      initialValues={
        selectedData.package_pattern == "additional service" ? dataAddOn : data
      }
      validationSchema={
        selectedData.package_pattern == "additional service"
          ? addonSchema
          : useSchema
      }
      onSubmit={(values, { setFieldError, resetForm, setSubmitting }) => {
        handleSubmit(values, setFieldError, setSubmitting);
      }}
    >
      {({ handleReset, values, setFieldValue, errors, isSubmitting }) => (
        <Form className="modal-form">
          <MDBRow className="form-group">
            <MDBCol>
              <MDBRow className="m-0">
                <MDBCol>
                  {/* <Input
                    label="Package Title"
                    // placeholder="Title"
                    name={`title`}
                  /> */}
                  <FieldArray name={`package_type`}>
                    {({ insert, remove, push }) => (
                      <MDBRow className="form-group">
                        <MDBCol className="col-12 col-md-3 form-label">
                          <label>Package Type</label>
                        </MDBCol>
                        <MDBCol>
                          {values.package_type.length > 0 &&
                            values.package_type.map((tag, packageTypeIndex) => (
                              <MDBRow className="p-0">
                                {/* <MDBCol className="col-12 col-md-3 form-label">
                          <label>Package Type</label>
                        </MDBCol> */}
                                <MDBCol>
                                  <Input
                                    placeholder="Package Type Name"
                                    name={`package_type.${packageTypeIndex}.package_type_name`}
                                  />
                                  {errors &&
                                  errors["package_type"] &&
                                  errors["package_type"][packageTypeIndex] &&
                                  errors["package_type"][packageTypeIndex][
                                    "package_type_name"
                                  ] ? (
                                    <div className="text-danger text-right no-padding error-message">
                                      {
                                        errors["package_type"][
                                          packageTypeIndex
                                        ]["package_type_name"]
                                      }
                                    </div>
                                  ) : null}
                                  <FieldArray
                                    name={`package_type.${packageTypeIndex}.package_type_item`}
                                  >
                                    {({ insert, remove, push }) => (
                                      <MDBRow className="form-group m-0">
                                        <MDBCol className="col-3 form-label p-0">
                                          <label className="p-0">
                                            Package Item
                                          </label>
                                        </MDBCol>
                                        <MDBCol className="p-0">
                                          {values.package_type[packageTypeIndex]
                                            .package_type_item.length > 0 &&
                                            values.package_type[
                                              packageTypeIndex
                                            ].package_type_item.map(
                                              (tag, packageTypeItemIndex) => (
                                                <MDBRow className="p-0">
                                                  <MDBCol className="package-type-item">
                                                    <Input
                                                      placeholder="Package Item Name"
                                                      name={`package_type.${packageTypeIndex}.package_type_item.${packageTypeItemIndex}.package_type_item_name`}
                                                    />
                                                    {errors &&
                                                    errors["package_type"] &&
                                                    errors["package_type"][
                                                      packageTypeIndex
                                                    ] &&
                                                    errors["package_type"][
                                                      packageTypeIndex
                                                    ]["package_type_item"] &&
                                                    errors["package_type"][
                                                      packageTypeIndex
                                                    ]["package_type_item"][
                                                      packageTypeItemIndex
                                                    ] &&
                                                    errors["package_type"][
                                                      packageTypeIndex
                                                    ]["package_type_item"][
                                                      packageTypeItemIndex
                                                    ][
                                                      "package_type_item_name"
                                                    ] ? (
                                                      <div className="text-danger text-right no-padding error-message">
                                                        {
                                                          errors[
                                                            "package_type"
                                                          ][packageTypeIndex][
                                                            "package_type_item"
                                                          ][
                                                            packageTypeItemIndex
                                                          ][
                                                            "package_type_item_name"
                                                          ]
                                                        }
                                                      </div>
                                                    ) : null}
                                                    <Input
                                                      placeholder="Package Item Pricing"
                                                      name={`package_type.${packageTypeIndex}.package_type_item.${packageTypeItemIndex}.package_type_item_pricing`}
                                                    />
                                                    {errors &&
                                                    errors["package_type"] &&
                                                    errors["package_type"][
                                                      packageTypeIndex
                                                    ] &&
                                                    errors["package_type"][
                                                      packageTypeIndex
                                                    ]["package_type_item"] &&
                                                    errors["package_type"][
                                                      packageTypeIndex
                                                    ]["package_type_item"][
                                                      packageTypeItemIndex
                                                    ] &&
                                                    errors["package_type"][
                                                      packageTypeIndex
                                                    ]["package_type_item"][
                                                      packageTypeItemIndex
                                                    ][
                                                      "package_type_item_pricing"
                                                    ] ? (
                                                      <div className="text-danger text-right no-padding error-message">
                                                        {
                                                          errors[
                                                            "package_type"
                                                          ][packageTypeIndex][
                                                            "package_type_item"
                                                          ][
                                                            packageTypeItemIndex
                                                          ][
                                                            "package_type_item_pricing"
                                                          ]
                                                        }
                                                      </div>
                                                    ) : null}
                                                    <Input
                                                      placeholder="Limit of this package item"
                                                      name={`package_type.${packageTypeIndex}.package_type_item.${packageTypeItemIndex}.package_type_item_limit`}
                                                    />
                                                    {errors &&
                                                    errors["package_type"] &&
                                                    errors["package_type"][
                                                      packageTypeIndex
                                                    ] &&
                                                    errors["package_type"][
                                                      packageTypeIndex
                                                    ]["package_type_item"] &&
                                                    errors["package_type"][
                                                      packageTypeIndex
                                                    ]["package_type_item"][
                                                      packageTypeItemIndex
                                                    ] &&
                                                    errors["package_type"][
                                                      packageTypeIndex
                                                    ]["package_type_item"][
                                                      packageTypeItemIndex
                                                    ][
                                                      "package_type_item_limit"
                                                    ] ? (
                                                      <div className="text-danger text-right no-padding error-message">
                                                        {
                                                          errors[
                                                            "package_type"
                                                          ][packageTypeIndex][
                                                            "package_type_item"
                                                          ][
                                                            packageTypeItemIndex
                                                          ][
                                                            "package_type_item_limit"
                                                          ]
                                                        }
                                                      </div>
                                                    ) : null}
                                                  </MDBCol>
                                                  <MDBRow
                                                    className="m-0"
                                                    style={{
                                                      padding: "0em 0.5em",
                                                    }}
                                                  >
                                                    {/* <MDBCol className="col-3"></MDBCol> */}

                                                    <MDBCol className="p-0 form-group package-item-button">
                                                      {values.package_type[
                                                        packageTypeIndex
                                                      ].package_type_item[
                                                        packageTypeItemIndex
                                                      ] === undefined ? (
                                                        <button
                                                          type="button"
                                                          className={
                                                            packageTypeItemIndex >=
                                                            values.package_type[
                                                              packageTypeIndex
                                                            ].package_type_item
                                                              .length -
                                                              1
                                                              ? "add-button"
                                                              : "remove-button"
                                                          }
                                                          onClick={() => {
                                                            packageTypeItemIndex >=
                                                            values.package_type[
                                                              packageTypeIndex
                                                            ].package_type_item
                                                              .length -
                                                              1
                                                              ? push()
                                                              : remove(
                                                                  packageTypeItemIndex
                                                                );
                                                          }}
                                                        >
                                                          {packageTypeItemIndex >=
                                                          values.package_type[
                                                            packageTypeIndex
                                                          ].package_type_item
                                                            .length -
                                                            1
                                                            ? "Add Package Item"
                                                            : "Remove Package Item"}
                                                        </button>
                                                      ) : (
                                                        <button
                                                          type="button"
                                                          className={
                                                            packageTypeItemIndex >=
                                                            values.package_type[
                                                              packageTypeIndex
                                                            ].package_type_item
                                                              .length -
                                                              1
                                                              ? "add-button"
                                                              : "add-button"
                                                          }
                                                          onClick={() => {
                                                            packageTypeItemIndex >=
                                                            values.package_type[
                                                              packageTypeIndex
                                                            ].package_type_item
                                                              .length -
                                                              1
                                                              ? push()
                                                              : push();
                                                          }}
                                                        >
                                                          {packageTypeItemIndex >=
                                                          values.package_type[
                                                            packageTypeIndex
                                                          ].package_type_item
                                                            .length -
                                                            1
                                                            ? "Add Package Item"
                                                            : "Add Package Item"}
                                                        </button>
                                                      )}
                                                    </MDBCol>
                                                  </MDBRow>
                                                </MDBRow>
                                              )
                                            )}
                                        </MDBCol>
                                      </MDBRow>
                                    )}
                                  </FieldArray>
                                  {selectedData.package_pattern ==
                                    "additional service" &&
                                  values.package_type[packageTypeIndex]
                                    .package_type_item_addon ? (
                                    <FieldArray
                                      name={`package_type.${packageTypeIndex}.package_type_item_addon`}
                                    >
                                      {({ insert, remove, push }) => (
                                        <MDBRow className="form-group m-0">
                                          <MDBCol className="col-3 form-label">
                                            <label>Add On Service</label>
                                          </MDBCol>
                                          <MDBCol className="p-0">
                                            {values.package_type[
                                              packageTypeIndex
                                            ].package_type_item_addon.length >
                                              0 &&
                                              values.package_type[
                                                packageTypeIndex
                                              ].package_type_item_addon.map(
                                                (
                                                  tag,
                                                  packageTypeItemAddOnIndex
                                                ) => (
                                                  <MDBRow className="p-0">
                                                    <MDBCol className="col package-type-item">
                                                      <Input
                                                        placeholder=" Service (Name)"
                                                        name={`package_type.${packageTypeIndex}.package_type_item_addon.${packageTypeItemAddOnIndex}.add_on_name`}
                                                      />
                                                      {errors &&
                                                      errors["package_type"] &&
                                                      errors["package_type"][
                                                        packageTypeIndex
                                                      ] &&
                                                      errors["package_type"][
                                                        packageTypeIndex
                                                      ][
                                                        "package_type_item_addon"
                                                      ] &&
                                                      errors["package_type"][
                                                        packageTypeIndex
                                                      ][
                                                        "package_type_item_addon"
                                                      ][
                                                        packageTypeItemAddOnIndex
                                                      ] &&
                                                      errors["package_type"][
                                                        packageTypeIndex
                                                      ][
                                                        "package_type_item_addon"
                                                      ][
                                                        packageTypeItemAddOnIndex
                                                      ]["add_on_name"] ? (
                                                        <div className="text-danger text-right no-padding error-message">
                                                          {
                                                            errors[
                                                              "package_type"
                                                            ][packageTypeIndex][
                                                              "package_type_item_addon"
                                                            ][
                                                              packageTypeItemAddOnIndex
                                                            ]["add_on_name"]
                                                          }
                                                        </div>
                                                      ) : null}
                                                      <FieldArray
                                                        name={`package_type.${packageTypeIndex}.package_type_item_addon.${packageTypeItemAddOnIndex}.add_on_item`}
                                                      >
                                                        {({
                                                          insert,
                                                          remove,
                                                          push,
                                                        }) => (
                                                          <MDBRow className="form-group m-0">
                                                            <MDBCol className="col-3 form-label">
                                                              <label>
                                                                Service Option
                                                              </label>
                                                            </MDBCol>
                                                            <MDBCol className="p-0">
                                                              {values
                                                                .package_type[
                                                                packageTypeIndex
                                                              ]
                                                                .package_type_item_addon[
                                                                packageTypeItemAddOnIndex
                                                              ].add_on_item
                                                                .length > 0 &&
                                                                values.package_type[
                                                                  packageTypeIndex
                                                                ].package_type_item_addon[
                                                                  packageTypeItemAddOnIndex
                                                                ].add_on_item.map(
                                                                  (
                                                                    tag,
                                                                    packageTypeItemAddOnItemIndex
                                                                  ) => (
                                                                    <MDBRow className="p-0">
                                                                      <MDBCol className="col">
                                                                        <Input
                                                                          placeholder="Option (Name)"
                                                                          name={`package_type.${packageTypeIndex}.package_type_item_addon.${packageTypeItemAddOnIndex}.add_on_item.${packageTypeItemAddOnItemIndex}.add_on_item_name`}
                                                                        />
                                                                        {errors &&
                                                                        errors[
                                                                          "package_type"
                                                                        ] &&
                                                                        errors[
                                                                          "package_type"
                                                                        ][
                                                                          packageTypeIndex
                                                                        ] &&
                                                                        errors[
                                                                          "package_type"
                                                                        ][
                                                                          packageTypeIndex
                                                                        ][
                                                                          "package_type_item_addon"
                                                                        ] &&
                                                                        errors[
                                                                          "package_type"
                                                                        ][
                                                                          packageTypeIndex
                                                                        ][
                                                                          "package_type_item_addon"
                                                                        ][
                                                                          packageTypeItemAddOnIndex
                                                                        ] &&
                                                                        errors[
                                                                          "package_type"
                                                                        ][
                                                                          packageTypeIndex
                                                                        ][
                                                                          "package_type_item_addon"
                                                                        ][
                                                                          packageTypeItemAddOnIndex
                                                                        ] &&
                                                                        errors[
                                                                          "package_type"
                                                                        ][
                                                                          packageTypeIndex
                                                                        ][
                                                                          "package_type_item_addon"
                                                                        ][
                                                                          packageTypeItemAddOnIndex
                                                                        ][
                                                                          "add_on_item"
                                                                        ] &&
                                                                        errors[
                                                                          "package_type"
                                                                        ][
                                                                          packageTypeIndex
                                                                        ][
                                                                          "package_type_item_addon"
                                                                        ][
                                                                          packageTypeItemAddOnIndex
                                                                        ][
                                                                          "add_on_item"
                                                                        ][
                                                                          packageTypeItemAddOnItemIndex
                                                                        ] &&
                                                                        errors[
                                                                          "package_type"
                                                                        ][
                                                                          packageTypeIndex
                                                                        ][
                                                                          "package_type_item_addon"
                                                                        ][
                                                                          packageTypeItemAddOnIndex
                                                                        ][
                                                                          "add_on_item"
                                                                        ][
                                                                          packageTypeItemAddOnItemIndex
                                                                        ][
                                                                          "add_on_item_name"
                                                                        ] ? (
                                                                          <div className="text-danger text-right no-padding error-message">
                                                                            {
                                                                              errors[
                                                                                "package_type"
                                                                              ][
                                                                                packageTypeIndex
                                                                              ][
                                                                                "package_type_item_addon"
                                                                              ][
                                                                                packageTypeItemAddOnIndex
                                                                              ][
                                                                                "add_on_item"
                                                                              ][
                                                                                packageTypeItemAddOnItemIndex
                                                                              ][
                                                                                "add_on_item_name"
                                                                              ]
                                                                            }
                                                                          </div>
                                                                        ) : null}
                                                                        <Input
                                                                          placeholder="Option (Price)"
                                                                          name={`package_type.${packageTypeIndex}.package_type_item_addon.${packageTypeItemAddOnIndex}.add_on_item.${packageTypeItemAddOnItemIndex}.add_on_item_pricing`}
                                                                        />
                                                                      </MDBCol>
                                                                      {errors &&
                                                                      errors[
                                                                        "package_type"
                                                                      ] &&
                                                                      errors[
                                                                        "package_type"
                                                                      ][
                                                                        packageTypeIndex
                                                                      ] &&
                                                                      errors[
                                                                        "package_type"
                                                                      ][
                                                                        packageTypeIndex
                                                                      ][
                                                                        "package_type_item_addon"
                                                                      ] &&
                                                                      errors[
                                                                        "package_type"
                                                                      ][
                                                                        packageTypeIndex
                                                                      ][
                                                                        "package_type_item_addon"
                                                                      ][
                                                                        packageTypeItemAddOnIndex
                                                                      ] &&
                                                                      errors[
                                                                        "package_type"
                                                                      ][
                                                                        packageTypeIndex
                                                                      ][
                                                                        "package_type_item_addon"
                                                                      ][
                                                                        packageTypeItemAddOnIndex
                                                                      ] &&
                                                                      errors[
                                                                        "package_type"
                                                                      ][
                                                                        packageTypeIndex
                                                                      ][
                                                                        "package_type_item_addon"
                                                                      ][
                                                                        packageTypeItemAddOnIndex
                                                                      ][
                                                                        "add_on_item"
                                                                      ] &&
                                                                      errors[
                                                                        "package_type"
                                                                      ][
                                                                        packageTypeIndex
                                                                      ][
                                                                        "package_type_item_addon"
                                                                      ][
                                                                        packageTypeItemAddOnIndex
                                                                      ][
                                                                        "add_on_item"
                                                                      ][
                                                                        packageTypeItemAddOnItemIndex
                                                                      ] &&
                                                                      errors[
                                                                        "package_type"
                                                                      ][
                                                                        packageTypeIndex
                                                                      ][
                                                                        "package_type_item_addon"
                                                                      ][
                                                                        packageTypeItemAddOnIndex
                                                                      ][
                                                                        "add_on_item"
                                                                      ][
                                                                        packageTypeItemAddOnItemIndex
                                                                      ][
                                                                        "add_on_item_pricing"
                                                                      ] ? (
                                                                        <div className="text-danger text-right no-padding error-message">
                                                                          {
                                                                            errors[
                                                                              "package_type"
                                                                            ][
                                                                              packageTypeIndex
                                                                            ][
                                                                              "package_type_item_addon"
                                                                            ][
                                                                              packageTypeItemAddOnIndex
                                                                            ][
                                                                              "add_on_item"
                                                                            ][
                                                                              packageTypeItemAddOnItemIndex
                                                                            ][
                                                                              "add_on_item_pricing"
                                                                            ]
                                                                          }
                                                                        </div>
                                                                      ) : null}
                                                                      <MDBRow
                                                                        className="m-0"
                                                                        style={{
                                                                          padding:
                                                                            "0em 0.5em",
                                                                        }}
                                                                      >
                                                                        <MDBCol className="p-0 form-group package-item-button">
                                                                          <button
                                                                            type="button"
                                                                            className={
                                                                              packageTypeItemAddOnItemIndex >=
                                                                              values
                                                                                .package_type[
                                                                                packageTypeIndex
                                                                              ]
                                                                                .package_type_item_addon[
                                                                                packageTypeItemAddOnIndex
                                                                              ]
                                                                                .add_on_item
                                                                                .length -
                                                                                1
                                                                                ? "add-button"
                                                                                : "remove-button"
                                                                            }
                                                                            onClick={() => {
                                                                              {
                                                                                packageTypeItemAddOnItemIndex >=
                                                                                values
                                                                                  .package_type[
                                                                                  packageTypeIndex
                                                                                ]
                                                                                  .package_type_item_addon[
                                                                                  packageTypeItemAddOnIndex
                                                                                ]
                                                                                  .add_on_item
                                                                                  .length -
                                                                                  1
                                                                                  ? push()
                                                                                  : remove(
                                                                                      packageTypeItemAddOnItemIndex
                                                                                    );
                                                                              }
                                                                            }}
                                                                          >
                                                                            {packageTypeItemAddOnItemIndex >=
                                                                            values
                                                                              .package_type[
                                                                              packageTypeIndex
                                                                            ]
                                                                              .package_type_item_addon[
                                                                              packageTypeItemAddOnIndex
                                                                            ]
                                                                              .add_on_item
                                                                              .length -
                                                                              1
                                                                              ? " Add New Service Option"
                                                                              : "Remove Service Option"}
                                                                          </button>
                                                                        </MDBCol>
                                                                      </MDBRow>
                                                                    </MDBRow>
                                                                  )
                                                                )}
                                                            </MDBCol>
                                                          </MDBRow>
                                                        )}
                                                      </FieldArray>
                                                    </MDBCol>
                                                    <MDBRow
                                                      className="m-0"
                                                      style={{
                                                        padding: "0em 0.5em",
                                                      }}
                                                    >
                                                      <MDBCol className="p-0 form-group package-item-button">
                                                        <button
                                                          type="button"
                                                          className={
                                                            packageTypeItemAddOnIndex >=
                                                            values.package_type[
                                                              packageTypeIndex
                                                            ]
                                                              .package_type_item_addon
                                                              .length -
                                                              1
                                                              ? "add-button"
                                                              : "remove-button"
                                                          }
                                                          onClick={() => {
                                                            {
                                                              packageTypeItemAddOnIndex >=
                                                              values
                                                                .package_type[
                                                                packageTypeIndex
                                                              ]
                                                                .package_type_item_addon
                                                                .length -
                                                                1
                                                                ? push({
                                                                    add_on_name:
                                                                      "",
                                                                    add_on_item:
                                                                      [
                                                                        {
                                                                          add_on_item_name:
                                                                            "",
                                                                          add_on_item_pricing:
                                                                            "",
                                                                        },
                                                                      ],
                                                                  })
                                                                : remove(
                                                                    packageTypeItemAddOnIndex
                                                                  );
                                                            }
                                                          }}
                                                        >
                                                          {packageTypeItemAddOnIndex >=
                                                          values.package_type[
                                                            packageTypeIndex
                                                          ]
                                                            .package_type_item_addon
                                                            .length -
                                                            1
                                                            ? "New Add On Service"
                                                            : "Remove Add On Service"}
                                                        </button>
                                                      </MDBCol>
                                                    </MDBRow>
                                                  </MDBRow>
                                                )
                                              )}
                                          </MDBCol>
                                        </MDBRow>
                                      )}
                                    </FieldArray>
                                  ) : (
                                    ""
                                  )}
                                </MDBCol>
                                <MDBRow>
                                  {values.package_type[packageTypeIndex]
                                    .ticket_package_type_id === undefined ? (
                                    <button
                                      type="button"
                                      className={
                                        packageTypeIndex >=
                                        values.package_type.length - 1
                                          ? "form-group add-button"
                                          : values.package_type[
                                              packageTypeIndex
                                            ].ticket_package_type_id ===
                                            undefined
                                          ? "form-group remove-button"
                                          : ""
                                      }
                                      onClick={() => {
                                        packageTypeIndex >=
                                        values.package_type.length - 1
                                          ? selectedData.package_pattern ==
                                            "additional service"
                                            ? push({
                                                package_type_name: "",
                                                package_type_item: [
                                                  {
                                                    package_type_item_name: "",
                                                    package_type_item_pricing:
                                                      "",
                                                    package_type_item_limit: "",
                                                  },
                                                ],
                                                package_type_item_addon: [
                                                  {
                                                    add_on_name: "",
                                                    add_on_item: [
                                                      {
                                                        add_on_item_name: "",
                                                        add_on_item_pricing: "",
                                                      },
                                                    ],
                                                  },
                                                ],
                                              })
                                            : push({
                                                package_type_name: "",
                                                package_type_item: [
                                                  {
                                                    package_type_item_name: "",
                                                    package_type_item_pricing:
                                                      "",
                                                    package_type_item_limit: "",
                                                  },
                                                ],
                                              })
                                          : remove(packageTypeIndex);
                                      }}
                                    >
                                      {packageTypeIndex >=
                                      values.package_type.length - 1
                                        ? "Add Package Type"
                                        : values.package_type[packageTypeIndex]
                                            .ticket_package_type_id ===
                                          undefined
                                        ? "Remove Package Type"
                                        : ""}
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className={
                                        packageTypeIndex >=
                                        values.package_type.length - 1
                                          ? "form-group add-button"
                                          : values.package_type[
                                              packageTypeIndex
                                            ].ticket_package_type_id ===
                                            undefined
                                          ? "form-group remove-button"
                                          : "form-group add-button"
                                      }
                                      onClick={() => {
                                        packageTypeIndex >=
                                        values.package_type.length - 1
                                          ? selectedData.package_pattern ==
                                            "additional service"
                                            ? push({
                                                package_type_name: "",
                                                package_type_item: [
                                                  {
                                                    package_type_item_name: "",
                                                    package_type_item_pricing:
                                                      "",
                                                    package_type_item_limit: "",
                                                  },
                                                ],
                                                package_type_item_addon: [
                                                  {
                                                    add_on_name: "",
                                                    add_on_item: [
                                                      {
                                                        add_on_item_name: "",
                                                        add_on_item_pricing: "",
                                                      },
                                                    ],
                                                  },
                                                ],
                                              })
                                            : push({
                                                package_type_name: "",
                                                package_type_item: [
                                                  {
                                                    package_type_item_name: "",
                                                    package_type_item_pricing:
                                                      "",
                                                    package_type_item_limit: "",
                                                  },
                                                ],
                                              })
                                          : push({
                                              package_type_name: "",
                                              package_type_item: [
                                                {
                                                  package_type_item_name: "",
                                                  package_type_item_pricing: "",
                                                  package_type_item_limit: "",
                                                },
                                              ],
                                            });
                                      }}
                                    >
                                      {packageTypeIndex >=
                                      values.package_type.length - 1
                                        ? "Add Package Type"
                                        : values.package_type[packageTypeIndex]
                                            .ticket_package_type_id ===
                                          undefined
                                        ? "Remove Package Type"
                                        : "Add Package Type"}
                                    </button>
                                  )}
                                </MDBRow>
                              </MDBRow>
                            ))}
                        </MDBCol>
                      </MDBRow>
                    )}
                  </FieldArray>
                </MDBCol>
              </MDBRow>
            </MDBCol>
          </MDBRow>
          <Button name={"Save"} type="submit" isSubmitting={isSubmitting} />
        </Form>
      )}
    </Formik>
  );
}
